export default "__VITE_ASSET__DAYVAqq7__"